<ion-button fill="solid" size="small" [color]="color" (click)="handleClick($event)">
  Close
</ion-button>